var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcRectangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 7,
    viewBox: "0 0 36 7",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 0.27002H3.5C1.84315 0.27002 0.5 1.61317 0.5 3.27002C0.5 4.92687 1.84315 6.27002 3.5 6.27002H32.5C34.1569 6.27002 35.5 4.92687 35.5 3.27002C35.5 1.61317 34.1569 0.27002 32.5 0.27002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRectangle);
export default __webpack_public_path__ + "static/media/ic_rectangle.0915fbc61b0ce3d11fd37ebd280f7c4f.svg";
export { ForwardRef as ReactComponent };